module.exports = __webpack_public_path__ + "static/media/frames.60d18102.png";